import React from "react";
export default function NearbyAttract() {
  return (
      <section className="content-section light attractions-section">
        <div className="container">
            <div className="text-center mb-5">
                <h2 className="display-5 fw-bold attractions-title">Nearby Attractions</h2>
                <p className="attractions-subtitle">Discover the rich heritage and natural beauty surrounding our hotel. From historic forts to scenic viewpoints, explore the wonders of Panhala.</p>
            </div>
            
            <div className="row g-3">
                <div className="col-lg-4 col-md-6 mb-3">
                    <div className="attraction-card">
                        <h4 className="attraction-name">Panhala Fort</h4>
                        <div className="attraction-image">
                            <img src="Images/forts.jpg" alt="Panhala Fort" className="img-fluid"/>
                        </div>
                        <p className="attraction-description">Ancient hilltop fort with rich Maratha history, offering panoramic views of the Western Ghats and surrounding valleys.</p>
                        <div className="attraction-distance">
                            <div className="distance-label">Distance from Hotel</div>
                            <div className="distance-value">0.5 km</div>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-4 col-md-6 mb-3">
                    <div className="attraction-card">
                        <h4 className="attraction-name">Sajja Kothi</h4>
                        <div className="attraction-image">
                            <img src="Images/sajjakoti.jpg" alt="Sajja Kothi Watchtower" className="img-fuid"/>
                        _</div>
                        <p className="attraction-description">Historic watchtower and viewpoint offering breathtaking sunset views over the Sahyadri mountain range.</p>
                        <div className="attraction-distance">
                            <div className="distance-label">Distance from Hotel</div>
                            <div className="distance-value">1.2 km</div>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-4 col-md-6 mb-3">
                    <div className="attraction-card">
                        <h4 className="attraction-name">Tabak Udyan</h4>
                        <div className="attraction-image">
                            <img src="Images/tabakudyan.jpg" alt="Tabak Udyan" className="img-fluid"/>
                        </div>
                        <p className="attraction-description">Protected forest area with diverse flora and fauna, perfect for nature walks and bird watching.</p>
                        <div className="attraction-distance">
                            <div className="distance-label">Distance from Hotel</div>
                            <div className="distance-value">2.5 km</div>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-4 col-md-6 mb-3">
                    <div className="attraction-card">
                        <h4 className="attraction-name">Teen Darwaja</h4>
                        <div className="attraction-image">
                            <img src="Images/teendarwaja.jpg" alt="Teen Darwaja" className="img-fluid"/>
                        </div>
                        <p className="attraction-description">Serene nature surrounded by hills, ideal for peaceful walks and photography in the early morning light.</p>
                        <div className="attraction-distance">
                            <div className="distance-label">Distance from Hotel</div>
                            <div className="distance-value">3.0 km</div>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-4 col-md-6 mb-3">
                    <div className="attraction-card">
                        <h4 className="attraction-name">Pusati Buruj</h4>
                        <div className="attraction-image">
                            <img src="https://images.unsplash.com/photo-1551632811-561732d1e306?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Mountain Trekking Trails" className="img-fluid"/>
                        </div>
                        <p className="attraction-description">Various hiking routes through the Western Ghats, offering different difficulty levels and stunning vistas.</p>
                        <div className="attraction-distance">
                            <div className="distance-label">Distance from Hotel</div>
                            <div className="distance-value">1.8 km</div>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-4 col-md-6 mb-3">
                    <div className="attraction-card">
                        <h4 className="attraction-name">Masai Pathar</h4>
                        <div className="attraction-image">
                            <img src="Images/masaipathar.jpg" alt="Masai Pathar" className="img-fluid"/>
                        </div>
                        <p className="attraction-description">Vast grasslands, vibrant seasonal flowers, and breathtaking panoramic views.</p>
                        <div className="attraction-distance">
                            <div className="distance-label">Distance from Hotel</div>
                            <div className="distance-value">2.0 km</div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="attractions-highlight">
                <h5><i className="fas fa-info-circle text-primary me-2"></i>Perfect Base for Exploration</h5>
                <p>Our hotel's strategic location makes it the perfect base for exploring Panhala's rich heritage and natural wonders. All major attractions are within easy reach, allowing you to maximize your time experiencing the beauty and history of this remarkable region. Whether you're interested in history, nature, or adventure, everything is just a short distance away.</p>
            </div>
        </div>
    </section>
  )
}